<ng-template [ngTemplateOutlet]="templateElement"></ng-template>

<ng-template #typ00>
  {{ gsTyp00 }}
</ng-template>

<ng-template #typ01>
  {{ gsTyp01 }}
</ng-template>

<ng-template #typ02>
  {{ gsTyp02 }}
</ng-template>
